/* eslint-disable prefer-promise-reject-errors */
import { API_URL, ENDPOINTS, AUTH_CLIENT_ID, APP_VERSION } from "@constants";
import AbstractService from "./AbstractService";

export default class AccountService extends AbstractService {
	static endpoint = ENDPOINTS.accounts;

	static me() {
		if (localStorage.getItem("homeAccountId")) {
			return this.get({
				endpoint: this.endpoint,
			});
		}
		return Promise.reject(new Error("Logged out"));
	}

	// Login is a two-step transaction where a token must first be acquired.
	// Returns a promise until process has completed
	static login({ email, password }) {
		const data = {
			username: email,
			password,
			Authenticated: true,
			grant_type: "password", // eslint-disable-line camelcase
			client_id: AUTH_CLIENT_ID, // eslint-disable-line camelcase
		};

		// build the URL-encoded data for form submission via fetch
		const searchParamsObj = new URLSearchParams(data);

		// Request access token - skip SuperAgent as its not flexible enough in current implementation
		return new Promise((resolve, reject) => {
			fetch(`${API_URL}/${ENDPOINTS.token}`, {
				method: "POST",
				cache: "no-cache",
				mode: "cors",
				body: searchParamsObj,
			})
				.then(tokenResponse => {
					// Received a non-error response
					if (tokenResponse.ok) {
						tokenResponse.json().then(body => {
							localStorage.setItem("t", body.access_token);
							resolve(this.me());
						});
					} else {
						// eslint-disable-next-line prefer-promise-reject-errors
						tokenResponse
							.json()
							.then(body => reject({ error: tokenResponse.status, body }));
					}
				})
				.catch(error => {
					reject({ error, body: "Offline" }); // eslint-disable-line prefer-promise-reject-errors
				});
		});
	}

	static logout() {
		return this.post({
			endpoint: `${this.endpoint}/logout`,
		});
	}

	static register(contactId) {
		return this.post({
			endpoint: `${this.endpoint}/registration?contactId=${contactId}`,
		});
	}

	static resetPassword(email) {
		return this.get({
			endpoint: this.endpoint,
			queryParams: {
				email,
			},
		});
	}

	static updateAccount({
		FirstName,
		LastName,
		StreetAddress,
		City,
		Zip,
		StateId,
		TimeZoneId,
		CellPhone,
		UserPreferences,
		OrganizationEmail,
	}) {
		return this.put({
			endpoint: `${this.endpoint}/admin/profile`,
			data: {
				FirstName,
				LastName,
				StreetAddress,
				City,
				Zip,
				StateId,
				TimeZoneId,
				CellPhone,
				UserPreferences,
				OrganizationEmail,
			},
		});
	}

	static signUp({ data }) {
		return this.post({
			endpoint: `${this.endpoint}/agencysignup`,
			data,
		});
	}

	static verify(userId, data) {
		return this.put({
			endpoint: `${this.endpoint}/verifysmscode`,
			queryParams: { userId },
			data,
		});
	}

	static activate(id) {
		return this.get({
			endpoint: `${this.endpoint}/verifyemail`,
			queryParams: { id },
			allowAnonymous: true,
		});
	}

	static getDeviceInfo(iid) {
		return this.post({
			endpoint: `${this.endpoint}/iid?iid=${iid}`,
		});
	}

	static getDeviceTokens() {
		return this.get({
			endpoint: `${this.endpoint}/devicetokens`,
		});
	}

	static deleteDeviceToken(token) {
		return this.del({
			endpoint: `${this.endpoint}/devicetoken?token=${token}`,
		});
	}

	static updateDeviceToken(token) {
		return this.post({
			endpoint: `${this.endpoint}/devicetoken`,
			data: {
				DeviceToken: token,
				Platform: "Browser",
				AppVersion: APP_VERSION,
				DeviceModel: navigator.userAgent,
			},
		});
	}
}
